import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RadioInlineText from 'components/atoms/Radio/Radio.inlineText';
import FooterButton from 'components/atoms/Button/FooterButton';
import IconButton from 'components/atoms/Button/IconButton';
import { changeFontSize } from 'modules/actions/fontSize';
import { autoCompleteState } from 'modules/actions/autoComplete';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';
import PropTypes from 'prop-types';

const LeftSettingMenu = ({ styleDef }) => {
  /* font변경값 가져오기 */
  const currentFontSize = useSelector(state => state.fontSize.size);
  const autoCompleteStatus = useSelector(state => state.autoComplete.active);
  const settingMenuStatus = useSelector(state => state.isActive.settingMenu);
  const testRef = useRef(null);
  const dispatch = useDispatch();

  /* autoComplete on/off */
  const autoStatus = value => {
    sessionStorage.setItem('auto_active', value === 'on');
    dispatch(autoCompleteState(value === 'on'));
  };

  /* settingMenu 닫기 */
  const offSettingMenu = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
    document.querySelector('.set').focus();
  };

  /* font(변경)클릭시 action발생 */
  // const textSizeChange = e => {
  //   sessionStorage.setItem('font_size', e.target.value);
  //   dispatch(changeFontSize(Number(e.target.value)));
  // };

  const textSizeChange = value => {
    sessionStorage.setItem('font_size', value);
    dispatch(changeFontSize(Number(value)));
  };

  useEffect(() => {
    const restartBtnElement = document.querySelector('.restart');
    const headerCloseBtnElement = document.querySelector('._header_close');
    
    if(settingMenuStatus) {
      restartBtnElement.setAttribute('tabindex', '-1');
      headerCloseBtnElement.setAttribute('tabindex', '-1');
      disabledTabMoveButton(['label','closebtn','menu-trigger type7','_header_close','_at_icon_button_div set','_at_icon_button_div restart','label checked']);
      disabledTabMoveInput();
    } else {
      if(headerCloseBtnElement) {
        restartBtnElement.removeAttribute('tabindex');
        headerCloseBtnElement.removeAttribute('tabindex');
      }
      
      fallbackTabMove();
    }
  }, [settingMenuStatus]);

  return (
    <ul className="left_setting_area" style={styleDef}>
      <li className="left_setting_area_menu">
        폰트 크기 설정
        <div className="check_box">
          {currentFontSize === 12 ? <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='폰트 크기 작게' ref={testRef} className="label" onClick={() => textSizeChange(12)} style={{backgroundColor:'#005596', color:'white'}} title="선택됨">
           작게
          </button> : <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='폰트 크기 작게' className="label" onClick={() => textSizeChange(12)}>
           작게
          </button>}
         {currentFontSize === 14 ? <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='폰트 크기 보통' className="label" onClick={() =>textSizeChange(14)}
         style={{backgroundColor:'#005596', color:'white'}} title="선택됨">
           보통
          </button> : <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='폰트 크기 보통' className="label" onClick={() => textSizeChange(14)}> 
          보통
          </button>}

         {currentFontSize === 16 ? <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='폰트 크기 크게' className="label" onClick={() => textSizeChange(16)}
         style={{backgroundColor:'#005596', color:'white'}} title="선택됨">
           크게
          </button> : <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='폰트 크기 크게' className="label" onClick={() => textSizeChange(16)}>
           크게
          </button>}
        </div>
      </li>

      <li className="left_setting_area_menu">
        자동 완성 설정
        <div className="check_box">
          {/* <input id="autoCom_1" type="radio" name="autoCom" value="on" defaultChecked={autoCompleteStatus === true} />
          <RadioInlineText label="켜기" value="autoCom_1" /> */}

          {autoCompleteStatus === true ? <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} className="label" aria-label='자동완성 켜기' onClick={() => autoStatus('on')} style={{backgroundColor:'#005596', color:'white'}} title="선택됨">
           켜기
          </button> : <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='자동완성 켜기' className="label" onClick={() => autoStatus('on')}>
           켜기
          </button>}
          
        {autoCompleteStatus === false ? <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='자동완성 끄기' className="label" onClick={() => autoStatus('off')} style={{backgroundColor:'#005596', color:'white'}} title="선택됨">
           끄기
          </button> : <button type='button' aria-hidden={!settingMenuStatus} disabled={settingMenuStatus === true ? '': 'true'} aria-label='자동완성 끄기' className="label" onClick={() => autoStatus('off')}>
           끄기
          </button>}
          {/* <input id="autoCom_2" type="radio" name="autoCom" value="off" defaultChecked={autoCompleteStatus !== true} />
          <RadioInlineText label="끄기" value="autoCom_2" /> */}
        </div>
      </li>
      {/* <button type='button' className='closebtn' onClick={() => offSettingMenu()}> */}
      <div onClick={() => offSettingMenu()}>
        <li className="left_setting_area_menu">
          <button type='button' className='closebtn' disabled={settingMenuStatus === true ? '': 'true'} aria-label='닫기' aria-hidden={!settingMenuStatus} onClick={() => offSettingMenu()}>
          닫기
          <FooterButton icon="ri-close-line" styleDef={{ color: '#2C3134', fontSize: '26px', marginTop: '2px' }} viewStatus="" />
          </button>
        </li>
        </div>
      {/* </button> */}
    </ul>
  );
};

LeftSettingMenu.propTypes = {
  styleDef: PropTypes.object,
};
LeftSettingMenu.defaultProps = {
  styleDef: {},
};
export default LeftSettingMenu;
